import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { faqs } from '../data/breakFreeContent';
export function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="w-full bg-charcoal-950 py-14 sm:py-20" aria-labelledby="faq-title" data-id="element-41" data-mp="1bmlnh9z421lj">
      <div className="mx-auto max-w-2xl px-5" data-id="element-42" data-mp="1gjvgt0pmexen">
        <h2 id="faq-title" className="text-center font-display text-2xl font-semibold uppercase leading-tight text-ivory-50 sm:text-4xl" data-id="element-43" data-mp="248oa0peuyr5k">
          Questions you're asking
        </h2>

        <ul className="mt-9 divide-y divide-charcoal-600 border-y border-charcoal-600" data-id="element-44" data-mp="1uibqn0is5410">
          {faqs.map((faq, i) => {
          const isOpen = open === i;
          return <li key={faq.question} data-id="element-45" data-mp="2n7sdlinmrspu" data-mpi={i}>
                <h3 data-id="element-46" data-mp="2n6r1rbysj272">
                  <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-panel-${i}`} className="flex w-full items-center justify-between gap-5 py-4 text-left" data-id="element-47" data-mp="2n67hholo41pv">
                    <span className="font-display text-lg leading-snug text-ivory-50 sm:text-xl" data-id="element-48" data-mp="1eln0a13kxads">
                      {faq.question}
                    </span>
                    <PlusIcon className={`h-4 w-4 shrink-0 text-champagne transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} strokeWidth={2} aria-hidden="true" data-id="element-49" data-mp="19sk89xega8zp" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-50" data-mp="1sm66d2ohi6db">
                  {isOpen && <motion.div id={`faq-panel-${i}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-51" data-mp="36zsnqedjk0i">
                      <p className="pb-5 text-[14px] leading-relaxed text-body" data-id="element-52" data-mp="2867yq24ja3ka">
                        {faq.answer}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}